import React, { createContext, useCallback, useContext, useState } from 'react';

export type SidebarId = 'menu' | 'edit' | 'panel';

type UnifiedSidebarContextValue = {
  activeSidebar: SidebarId | null;
  open: (id: SidebarId) => void;
  close: () => void;
};

const UnifiedSidebarContext = createContext<UnifiedSidebarContextValue | undefined>(undefined);

export function useUnifiedSidebar() {
  const ctx = useContext(UnifiedSidebarContext);
  if (!ctx) throw new Error('useUnifiedSidebar must be used within UnifiedSidebarProvider');
  return ctx;
}

export function UnifiedSidebarProvider({ children }: { children: React.ReactNode }) {
  const [activeSidebar, setActiveSidebar] = useState<SidebarId | null>(null);

  const open = useCallback((id: SidebarId) => setActiveSidebar(id), []);
  const close = useCallback(() => setActiveSidebar(null), []);

  return (
    <UnifiedSidebarContext.Provider value={{ activeSidebar, open, close }}>
      {children}
    </UnifiedSidebarContext.Provider>
  );
}
